const version = '2.3.9' as string ;
export default version